// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__1wI_j","input_lg":"Input_input_lg__z0EwR","annotation":"Input_annotation__10UOv","annotationWarning":"Input_annotationWarning__Dsd2M"};